// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"e3086b2a","91":"5c620aa3"}[chunkId] + ".chunk.js";
};